import Tracker from './Tracker';

const subscriptionsTracker = new Tracker('subscription', {
	NOTICE_PERIOD: 'noticePeriod'
});

export default subscriptionsTracker;
